import template from './user-guardians.html';
import userGuardiansController from './user-guardians.controller';
import './user-guardians.styl';

let userGuardiansComponent = {
  restrict: 'E',
  bindings: {
    guardians: '<'
  },
  template,
  controller: userGuardiansController,
  controllerAs: 'vm'
};

export default userGuardiansComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-guardians/user-guardians.component.js
 **/